<template>
  <div>
    <div class="p-3">
      <h3 class="text-main-text text-sm md:text-lg leading-none md:leading-tight p-3 mb-8 rounded-5px"
          style="background: rgba(218, 218, 218, 0.2)">{{season.name}}</h3>
      <div class="lg:flex">
        <div class="text-center lg:w-1/2">
          <div class="flex justify-center relative">
            <p class="text-additional-text text-xs md:text-sm font-bold h-12 pt-1 md:pt--0">Количество<br> команд-чемпионов</p>
            <img src="@/assets/SVG/changeGameSeasonQuestionMark.svg"
                 alt="changeGameSeasonQuestionMark"
                 @mouseover="isPopoverOpen = true"
                 @mouseleave="isPopoverOpen = false"
                 @click="isPopoverOpen = !isPopoverOpen"
                 class="ml-2">
            <!-- prompt -->
            <div v-if="isPopoverOpen" class="absolute bg-white rounded p-2 shadow-lg text-left popover text-sm">
              Укажите количество<br>
              команд, которые попадут<br>
              на финальную игру сезона.<br>
              В рейтинге Чемпионов<br>
              они будут выделяться<br>
              отдельным цветом.<br>
            </div>
          </div>
          <input v-model="season.results_highlighted_count"
                 type="number" class="w-full lg:w-50 border-b-2 border-b-additional-text mt-5 text-center font-bold text-xl md:text-28px outline-none block mx-auto">
          <button @click="isSaveHighlightedModalOpen = true"
                  class="text-xs outline-none hover-up text-nowrap font-bold bg-brand-yellow text-main-text rounded-full py-3 mt-6 w-full lg:w-50">
            Изменить
          </button>
        </div>
        <div class="text-center pt-6 lg:pt-0 lg:w-1/2">
          <p class="text-sm text-additional-text self-center font-bold h-12">Текущий сезон игр</p>
          <p class="text-xs text-main-text self-center font-bold mt-3 md:mt-6 text-xl md:text-28px">{{season.season}}</p>
          <button @click="openIncreaseSeasonModal"
                  class="text-xs outline-none hover-up text-nowrap font-bold bg-brand-light text-white rounded-full py-3 mt-6 w-full lg:w-50">
            Начать новый сезон
          </button>
        </div>
      </div>
    </div>
    <increase-season-modal v-if="increaseSeasonModal"
                           @startNewSeason = "startNewSeason"
                           :seasonIncreased="seasonIncreased"
                           @close ="increaseSeasonModal=false;
                           seasonIncreased=false">
    </increase-season-modal>
    <save-highlights-modal v-if="isSaveHighlightedModalOpen"
                           @startNewSeason = "saveHighlighted"
                           :saved="saved"
                           @close ="isSaveHighlightedModalOpen=false;
                           saved=false">
    </save-highlights-modal>
  </div>
</template>

<script>
import client from '@/clients/partners';
import IncreaseSeasonModal from './increase-season-modal.vue';
import saveHighlightsModal from './saveHighlightsModal.vue';

export default {
  props: ['season'],
  components: { IncreaseSeasonModal, saveHighlightsModal },
  data() {
    return {
      increaseSeasonModal: false,
      isPopoverOpen: false,
      seasonIncreased: false,
      isSaveHighlightedModalOpen: false,
      saved: false,
    };
  },
  methods: {
    openIncreaseSeasonModal() {
      this.increaseSeasonModal = true;
    },
    startNewSeason() {
      client.post('/season/update', {
        product_id: this.season.product_id,
        season: this.season.season + 1,
        results_highlighted_count: this.season.results_highlighted_count,
      }).then(() => {
        this.seasonIncreased = true;
        this.$emit('getSeasons');
      });
    },
    saveHighlighted() {
      client.post('/season/update', {
        product_id: this.season.product_id,
        season: this.season.season,
        results_highlighted_count: this.season.results_highlighted_count,
      }).then(() => {
        this.saved = true;
      });
    },
  },
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.popover {
  right:-170px;
  top: -60px
}

@media (max-width: 767px) {
  .popover {
    right:40px;
    top: 40px
  }
}
</style>
